export const shortenNumber = (value) => {
    return value.toString().length > 3 ? value.toString().substring(0, value.toString().length - 3) + 'k' : value;
}